<ng-container [ngSwitch]="field?.ref">
    <erp-pbw-geschlecht *ngSwitchCase="'pbw_geschlecht'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-geschlecht>

    <erp-pbw-titel *ngSwitchCase="'pbw_titel'" [field]="field" [jobapplication]="jobApplication" [readonly]="readonly"
        (valueChange)="onChange($event)">
    </erp-pbw-titel>

    <erp-pbw-vornamen *ngSwitchCase="'pbw_vornamen'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-vornamen>

    <erp-pbw-namen *ngSwitchCase="'pbw_name'" [field]="field" [jobapplication]="jobApplication" [readonly]="readonly"
        (valueChange)="onChange($event)">
    </erp-pbw-namen>

    <erp-pbw-namenbestand *ngSwitchCase="'pbw_namenbestand'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-namenbestand>

    <erp-pbw-geburtsdatum *ngSwitchCase="'pbw_geburtsdatum'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-geburtsdatum>

    <erp-pbw-fam-stand *ngSwitchCase="'pbw_fam_stand'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-fam-stand>

    <erp-pbw-staatsangehoer *ngSwitchCase="'pbw_staatsangehoer'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-staatsangehoer>

    <erp-pbw-arbeitslos *ngSwitchCase="'pbw_arbeitslos'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-arbeitslos>

    <erp-pbw-behindert *ngSwitchCase="'pbw_behindert'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-behindert>

    <ng-container *ngSwitchCase="'pbw_prozent'">
        <erp-pbw-prozent *ngIf="jobApplication?.disability" [field]="field" [jobapplication]="jobApplication"
            [readonly]="readonly" (valueChange)="onChange($event)">
        </erp-pbw-prozent>
    </ng-container>

    <erp-pbw-hochschul *ngSwitchCase="'pbw_hochschul'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-hochschul>

    <erp-pbw-hoch-note *ngSwitchCase="'pbw_hoch_note'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-hoch-note>

    <erp-pbw-akad-grad *ngSwitchCase="'pbw_akad_grad'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-akad-grad>

    <erp-pbw-infoquelle *ngSwitchCase="'pbw_infoquelle'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-infoquelle>

    <erp-pbw-strasse *ngSwitchCase="'pbw_strasse'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-strasse>

    <erp-pbw-plz *ngSwitchCase="'pbw_plz'" [field]="field" [jobapplication]="jobApplication" [readonly]="readonly"
        (valueChange)="onChange($event)">
    </erp-pbw-plz>

    <erp-pbw-wohnort *ngSwitchCase="'pbw_wohnort'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-wohnort>

    <erp-pbw-zusatz *ngSwitchCase="'pbw_zusatz'" [field]="field" [jobapplication]="jobApplication" [readonly]="readonly"
        (valueChange)="onChange($event)">
    </erp-pbw-zusatz>

    <erp-pbw-land *ngSwitchCase="'pbw_land'" [field]="field" [jobapplication]="jobApplication" [readonly]="readonly"
        (valueChange)="onChange($event)">
    </erp-pbw-land>

    <erp-pbw-telefon *ngSwitchCase="'pbw_telefon'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-telefon>

    <erp-pbw-mobiltelefon *ngSwitchCase="'pbw_mobiltelefon'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-mobiltelefon>

    <erp-pbw-email *ngSwitchCase="'pbw_email'" [field]="field" [jobapplication]="jobApplication" [readonly]="readonly"
        (valueChange)="onChange($event)">
    </erp-pbw-email>

    <erp-pbw-teilzeitwunsch *ngSwitchCase="'pbw_teilzeitwunsch'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-teilzeitwunsch>

    <ng-container *ngSwitchCase="'pbw_teilzeitumfang'">
        <erp-pbw-teilzeitumfang *ngIf="jobApplication?.parttime" [field]="field" [jobapplication]="jobApplication"
            [readonly]="readonly" (valueChange)="onChange($event)">
        </erp-pbw-teilzeitumfang>
    </ng-container>

    <erp-pbw-tz-art *ngSwitchCase="'pbw_tz_art'" [field]="field" [jobapplication]="jobApplication" [readonly]="readonly"
        (valueChange)="onChange($event)">
    </erp-pbw-tz-art>

    <erp-pbw-frueh-eintritt *ngSwitchCase="'pbw_frueh_eintritt'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-frueh-eintritt>

    <erp-pbw-gehaltswunsch *ngSwitchCase="'pbw_gehaltswunsch'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-gehaltswunsch>

    <erp-pbw-adt-bez *ngSwitchCase="'pbw_adt_bez'" [field]="field" [jobapplication]="jobApplication"
        [readonly]="readonly" (valueChange)="onChange($event)">
    </erp-pbw-adt-bez>
</ng-container>
